import jwtDecode from 'jwt-decode'

import { isJwtFresh } from './is-jwt-fresh'

export const getPhoneFromJwtToken = (token: string) => {
	if (!token || !isJwtFresh(token)) return

	const decodeToken = jwtDecode(token)

	// @ts-ignore
	return decodeToken?.[`data`]?.[`phone_number`]
}
